import { render } from "./CompList.vue?vue&type=template&id=35994d90"
import script from "./CompList.vue?vue&type=script&lang=js"
export * from "./CompList.vue?vue&type=script&lang=js"

import "./CompList.vue?vue&type=style&index=0&id=35994d90&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__